import { connect } from 'react-redux'

import { actionTypes } from 'actions/actionTypes'
import {
  getSkipRecoveryContent,
  modalVisibilityChange,
  trackViewDiscountReminder,
  keepOrder,
  cancelOrder,
} from 'actions/onScreenRecovery'

import { OrderSkipOSRView } from './OrderSkipOSRView'

const mapStateToProps = (state) => ({
  triggered: state.onScreenRecovery.getIn(['orderSkip', 'triggered']),
  modalVisibility: state.onScreenRecovery.getIn(['orderSkip', 'modalVisibility']),
  orderId: state.onScreenRecovery.getIn(['orderSkip', 'orderId']),
  deliveryDayId: state.onScreenRecovery.getIn(['orderSkip', 'deliveryDayId']),
  title: state.onScreenRecovery.getIn(['orderSkip', 'title']),
  orderType: state.onScreenRecovery.getIn(['orderSkip', 'orderType']),
  offers: state.onScreenRecovery.getIn(['orderSkip', 'offers']),
  promoCode: state.onScreenRecovery.getIn(['orderSkip', 'promoCode']),
  offer:
    state.onScreenRecovery.getIn(['orderSkip', 'offer']) &&
    state.onScreenRecovery.getIn(['orderSkip', 'offer']).toJS(),
  cmsVariation: state.onScreenRecovery.getIn(['orderSkip', 'cmsVariation']),
  valueProposition: state.onScreenRecovery.getIn(['orderSkip', 'valueProposition']),
  modalType: state.onScreenRecovery.getIn(['orderSkip', 'modalType']),
  isFetching: state.pending.get(actionTypes.ORDER_SKIP_RECOVERY_TRIGGERED),
})

const mapDispatchToProps = {
  onKeep: keepOrder,
  onConfirm: cancelOrder,
  modalVisibilityChange,
  getSkipRecoveryContent,
  trackViewDiscountReminder,
}

export const OrderSkipOSRViewContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrderSkipOSRView)
